import './HomeAdditionalPart.css';
import Logo1 from '../imgs/logo/1.jpg';
import Logo2 from '../imgs/logo/2.jpg';
import Logo3 from '../imgs/logo/3.jpg';
import Logo4 from '../imgs/logo/4.jpg';
import Logo5 from '../imgs/logo/5.jpg';
import Logo6 from '../imgs/logo/6.jpg';
import Logo7 from '../imgs/logo/7.jpg';
import Logo8 from '../imgs/logo/8.jpg';
import Logo9 from '../imgs/logo/9.jpg';
import Logo10 from '../imgs/logo/10.jpg';
import Logo11 from '../imgs/logo/11.jpg';

function HomeAdditionalPart(){
    
    return (
        <div>
            <div class="logo-wrapper">
                <div class="logo-container">

                    <img src={Logo1} alt='1'></img>
                    <img src={Logo2} alt='2'></img>
                    <img src={Logo3} alt='3'></img>
                    <img src={Logo4} alt='4'></img>
                    <img src={Logo5} alt='5'></img>
                    <img src={Logo6} alt='6'></img>
                    <img src={Logo7} alt='7'></img>
                    <img src={Logo8} alt='8'></img>
                    <img src={Logo9} alt='9'></img>
                    <img src={Logo10} alt='10'></img>
                    <img src={Logo11} alt='11'></img>
                </div>
            </div>
        </div> 
   )
}

export default HomeAdditionalPart;